import { render } from "./CarouselPreviewComp.vue?vue&type=template&id=fc80f566&scoped=true&ts=true"
import script from "./CarouselPreviewComp.vue?vue&type=script&lang=ts"
export * from "./CarouselPreviewComp.vue?vue&type=script&lang=ts"

import "./CarouselPreviewComp.vue?vue&type=style&index=0&id=fc80f566&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc80f566"]])

export default __exports__